import * as yup from "yup";

export const emailSchema = yup.object({
  email: yup
    .string()
    .required("Email requerido")
    .matches(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, { message: "Ingrese un mail valido", excludeEmptyString: true }),
});
